import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { HiMiniHome } from "react-icons/hi2";
import { IoIosKey } from "react-icons/io";
import ButtonLoader from "../../components/common/ButtonLoader";

const Login = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({
    phoneNumber: "",
    password: "",
    general: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    let valid = true;
    const newErrors = { phoneNumber: "", password: "", general: "" };

    if (!phoneNumber) {
      newErrors.phoneNumber = "Phone number is required.";
      valid = false;
    } else if (!/^\d{10}$/.test(phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 10 digits.";
      valid = false;
    }

    if (!password) {
      newErrors.password = "Password is required.";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleLogin = async () => {
    console.log("enter");
    if (!validateForm()) return;

    setIsLoading(true);
    setErrors({ phoneNumber: "", password: "", general: "" });

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/login`,
        {
          phoneNumber,
          password,
        },
       
      );
      console.log("login data", response.data);

      if (response.data.user.userType === "admin") {
        localStorage.setItem("userData", JSON.stringify(response.data.user));
        navigate("/dashboard");
      } else {
        setErrors({ phoneNumber: "", password: "", general: "" });
        navigate("/");
      }
    } catch (error) {
      console.error("Login error:", error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 404) {
          setErrors({
            phoneNumber: "",
            password: "",
            general: "User not found.",
          });
        } else if (status === 401) {
          setErrors({
            phoneNumber: "",
            password: "",
            general: "Invalid credentials.",
          });
        } else {
          setErrors({
            phoneNumber: "",
            password: "",
            general: data.message || "Login failed. Please try again.",
          });
        }
      } else {
        setErrors({
          phoneNumber: "",
          password: "",
          general: "Network error. Please check your connection.",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-tr from-[#0BB6D9] to-[#3cd7f6] flex items-center justify-center px-4">
      <div className="w-full max-w-lg bg-white rounded-xl shadow-xl p-10">
        <h1 className="text-center text-2xl font-bold text-[#0bb6d9] mb-1">
          Welcome Back!
        </h1>
        <p className="text-center text-sm text-gray-500 mb-6">
          Enter your credentials to continue
        </p>

        <div className="space-y-5">
          {errors.general && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-md text-sm">
              {errors.general}
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Phone Number
            </label>
            <input
              type="text"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className={`mt-1 block w-full px-4 py-2 border ${
                errors.phoneNumber ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0bb6d9]`}
              placeholder="Enter 10 digit phone number"
            />
            {errors.phoneNumber && (
              <p className="text-xs text-red-500 mt-1">{errors.phoneNumber}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={`mt-1 block w-full px-4 py-2 border ${
                errors.password ? "border-red-500" : "border-gray-300"
              } rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#0bb6d9]`}
              placeholder="Enter your password"
            />
            {errors.password && (
              <p className="text-xs text-red-500 mt-1">{errors.password}</p>
            )}
          </div>

          <div>
            <button
              onClick={handleLogin}
              disabled={isLoading}
              className="w-full h-12 flex justify-center items-center bg-[#0bb6d9] text-white font-semibold rounded-md transition hover:bg-[#069ab7] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? <ButtonLoader /> : "Login"}
            </button>
          </div>

          <div className="flex justify-between text-sm mt-4">
            <button
              onClick={() => navigate("/")}
              className="flex items-center gap-1 text-gray-600 hover:text-[#0bb6d9]"
            >
              <HiMiniHome size={18} /> Home
            </button>
            <button
              onClick={() => navigate("/forgot-password")}
              className="flex items-center gap-1 text-gray-600 hover:text-[#0bb6d9]"
            >
              <IoIosKey size={18} /> Forgot Password
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
